import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, CheckGrid, CTABand } from "../components/site/ContentBlocks";
import { FadeUp } from "../components/site/Reveal";
import { COMPANY_DETAILS, IMAGES } from "../data/content";

const MAURITIUS_POINTS = [
    "Mauritius is the registered corporate base of Viet Medica Ltd",
    "Mauritius is positioned between Africa and Asia",
    "A multicultural and internationally connected country",
    "Our Mauritius base supports relationships across Asia, Africa, the Middle East and Europe",
    "Mauritius represents the group's international, multicultural and outward-looking identity",
];

export default function MauritiusPage() {
    return (
        <div className="grain bg-navy-deep" data-testid="mauritius-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Registered in Mauritius | International Business Group — Viet Medica Ltd",
                        description:
                            "Viet Medica Ltd is a Mauritius-registered international company connecting Asia, Africa, the Middle East and Europe through healthcare coordination and global trading.",
                        path: "/mauritius",
                    }}
                    crumbs={[{ label: "About", href: "/about" }, { label: "Mauritius" }]}
                    eyebrow="Our Corporate Base"
                    title="Registered in Mauritius."
                    titleEm="Connected to the World."
                    copy="Viet Medica Ltd is registered in Mauritius, an internationally connected island nation positioned between Africa and Asia. From this corporate base, our wider network develops relationships across Asia, Africa, the Middle East and Europe."
                />

                <section className="bg-navy-deep pb-4">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <FadeUp>
                            <div className="relative overflow-hidden border border-white/8">
                                <img
                                    src={IMAGES.mauritius}
                                    alt="Turquoise lagoon and coastline of Mauritius from the air"
                                    loading="lazy"
                                    className="h-[300px] w-full object-cover lg:h-[440px]"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 via-transparent to-transparent" aria-hidden="true" />
                                <span className="absolute bottom-5 left-6 text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">
                                    Mauritius — Between Africa and Asia
                                </span>
                            </div>
                        </FadeUp>
                    </div>
                </section>

                <PageSection eyebrow="Why Mauritius" title="An Outward-Looking Corporate Home" testid="mauritius-points">
                    <CheckGrid items={MAURITIUS_POINTS} />
                </PageSection>

                <PageSection light eyebrow="Company Details" title="Corporate Information" testid="mauritius-details">
                    <FadeUp>
                        <div className="max-w-2xl border border-navy-deep/10 bg-white p-8 lg:p-10">
                            {COMPANY_DETAILS.map((d) => (
                                <div
                                    key={d.id}
                                    data-testid={`mauritius-field-${d.id}`}
                                    className="flex flex-col gap-1 border-t border-navy-deep/10 py-4 first:border-t-0 sm:flex-row sm:items-center sm:justify-between"
                                >
                                    <span className="text-sm font-semibold text-navy-deep/85">{d.label}</span>
                                    {d.value ? (
                                        <span className="text-sm text-navy-deep/80 sm:text-right">{d.value}</span>
                                    ) : (
                                        <span className="text-[11px] uppercase tracking-[0.22em] text-navy-deep/40">To be confirmed</span>
                                    )}
                                </div>
                            ))}
                            <p className="mt-6 border-t border-navy-deep/10 pt-6 text-xs leading-relaxed text-navy-deep/50">
                                Viet Medica Ltd is registered in Mauritius. For corporate enquiries, use the
                                details above or the enquiry forms on this website.
                            </p>
                        </div>
                    </FadeUp>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Connect with our Mauritius-registered group."
                            primary={{ label: "Speak to Our Team", to: "/contact", testid: "mauritius-contact-cta" }}
                            secondary={{ label: "About Viet Medica", to: "/about", testid: "mauritius-about-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
